import React from 'react';
import './footer.css';

function Footer() {
  return (
    <footer className='footer'>
      Made with ❤️ by Rahul. Last Updated on <i>December 2025 </i>.
    </footer>
  )
}

export default Footer;
